import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

const ReelsProfile = ({userId, profileId}) => {
    return (
        <div className="profile-container"></div>
    );
};

export default ReelsProfile;